import { render, staticRenderFns } from "./UserGiftUpselling.vue?vue&type=template&id=25bc3ea3&scoped=true&"
import script from "./UserGiftUpselling.vue?vue&type=script&lang=ts&"
export * from "./UserGiftUpselling.vue?vue&type=script&lang=ts&"
import style0 from "./UserGiftUpselling.vue?vue&type=style&index=0&id=25bc3ea3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25bc3ea3",
  null
  
)

export default component.exports